import React, {ReactNode} from "react";
import {Box, Colors, Text} from "@bounce/shared/ui";

type Props = {
  children: ReactNode;
  required?: boolean;
  fieldKey?: string;
};

const FieldLabel = ({children, required = false, fieldKey}: Props) => (
  <Box sx={{display: "flex", alignItems: "center", gap: 1, mb: 0.5}}>
    <Text size={12} sx={{color: Colors.grey._700}}>
      {children}
      {required && <span style={{color: Colors.red._700}}> *</span>}
    </Text>
    {fieldKey && (
      <Text size={11} sx={{color: Colors.grey._500, fontFamily: "monospace"}}>
        {fieldKey}
      </Text>
    )}
  </Box>
);

export default FieldLabel;
